/**
 * Suggeriment automatic de pais/moneda.
 *
 * Obre el modal #localization-modal un sol cop per visitant si Shopify detecta
 * que es a un pais diferent del que esta veient (p. ex. algu dels EUA veient
 * preus en euros).
 *
 * L'obertura a demanda NO passa per aqui: l'enllac del peu porta
 * [data-modal-toggle] i theme.js ja l'escolta.
 *
 * Endpoint natiu de Shopify, sense cap app:
 * https://shopify.dev/docs/storefronts/themes/markets/localization-discovery
 *
 * ⚠️ Aquest fitxer NO ha d'inicialitzar mai els .disclosure del modal.
 * Ho fa theme.FooterSection.onSectionLoad(), i fer-ho tambe aqui deixava DOS
 * handlers per clic al toggle: un obria la llista i l'altre la tancava dins del
 * mateix clic, de manera que el desplegable semblava bloquejat. FooterSection
 * crea la instancia sense comprovar si ja n'hi ha (theme.js:6444), i els
 * handlers de la primera es queden enganxats al DOM per sempre.
 *
 * Ha d'anar DESPRES de theme.js, que es qui defineix showInPageModal().
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'hb-localization-seen';

  // Al personalitzador no ha de saltar mai: molestaria en cada recarrega.
  if (window.Shopify && window.Shopify.designMode) return;

  var modal = document.getElementById('localization-modal');
  if (!modal) return;

  // Nomes se suggereix un cop per visitant. localStorage pot petar (mode privat,
  // cookies bloquejades); si no es pot llegir, val mes no ensenyar res que
  // insistir. Nomes afecta el suggeriment automatic: el boto i l'enllac han de
  // seguir funcionant sempre.
  function alreadySuggested() {
    try {
      return !!localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return true;
    }
  }

  function remember() {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {
      /* mode privat: s'ensenyara un altre cop, tampoc es greu */
    }
  }

  /**
   * El footer es registra amb carrega diferida (theme.js:8240): no s'inicialitza
   * fins que el peu queda a menys de 1200px del viewport. Si obrim el modal
   * abans, els seus .disclosure encara no tenen instancia i no s'obririen.
   *
   * En lloc de crear-la nosaltres (que duplicaria handlers quan el tema hi
   * arribes), es fa carregar la seccio ara: aixi la instancia la crea sempre
   * FooterSection, una sola vegada.
   */
  function ensureFooterLoaded() {
    var sections = window.theme && window.theme.Sections;
    if (!sections || typeof sections.sectionLoad !== 'function') return;

    var footer = modal.closest('[data-section-type="footer"]');
    if (!footer) return;

    var pending = sections._deferredSectionTargets || [];
    for (var i = 0; i < pending.length; i++) {
      if (pending[i].target !== footer) continue;
      // Treure'l de la cua ABANS de carregar-lo: _processDeferredSections nomes
      // fa splice dels que carrega ell, i si el deixem hi tornaria en fer scroll.
      pending.splice(i, 1);
      sections.sectionLoad(footer);
      return;
    }
  }

  /**
   * El boto de moneda viu a la capcalera, pero el modal es dins de la seccio del
   * footer. Si l'usuari el clica sense haver fet scroll, la seccio encara no
   * s'ha carregat i els desplegables no responen.
   *
   * theme.js obre el modal directament amb [data-modal-toggle] (theme.js:8015),
   * sense saber res d'aixo. S'intercepta el clic en fase de CAPTURA per
   * carregar la seccio abans que hi arribi.
   */
  document.addEventListener('click', function (evt) {
    var trigger = evt.target.closest('a[data-modal-toggle="#localization-modal"]');
    if (trigger) ensureFooterLoaded();
  }, true);

  if (alreadySuggested()) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var current = (window.Shopify && window.Shopify.country) || '';

  fetch(
    root + 'browsing_context_suggestions.json' +
    '?country[enabled]=true&country[exclude]=' + encodeURIComponent(current)
  )
    .then(function (response) {
      return response.ok ? response.json() : null;
    })
    .then(function (data) {
      if (!data || !data.suggestions || !data.suggestions.length) return;

      var parts = data.suggestions[0].parts || {};
      var country = parts.country;
      // Sense suggeriment de pais vol dir que ja hi som: no cal molestar.
      if (!country || !country.name) return;

      var text = modal.querySelector('[data-localization-suggestion]');
      var template = text && text.dataset.template;
      if (text && template) {
        // La traduccio ve del Liquid amb __COUNTRY__ com a marcador de posicio.
        text.textContent = template.replace('__COUNTRY__', country.name);
        text.hidden = false;
      }

      if (typeof window.showInPageModal === 'function' && window.jQuery) {
        ensureFooterLoaded();
        window.showInPageModal(window.jQuery(modal));
        remember();
      }
    })
    .catch(function () {
      /* sense xarxa o endpoint no disponible: el modal segueix obrint-se a ma */
    });
})();
